const toSnake = (str: string): string =>
  str.replace(/[A-Z]/g, (letter, index) =>
    index === 0 ? letter.toLowerCase() : `_${letter.toLowerCase()}`
  );

export const toSnakeCase = <T>(obj: unknown): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj as T;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => toSnakeCase(item)) as unknown as T;
  }

  const result: Record<string, unknown> = {};
  for (const key of Object.keys(obj as Record<string, unknown>)) {
    result[toSnake(key)] = toSnakeCase((obj as Record<string, unknown>)[key]);
  }

  return result as T;
};
